export default __webpack_public_path__ + "static/media/guide_import_1.e9643981.jpg";